import React from "react";
// reactstrap components
import {Card, CardBody, CardHeader, CardTitle, Col, Container, FormGroup, Nav, NavItem, NavLink, Row} from "reactstrap";
// core components
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import {report_strings} from "../../translations/report_translations";
import businessHelper from "../../helpers/BusinessHelper";
import Report from "../../components/reports/Report";
import constants from "../../shared/constants";
import ReportsHeader from "../../components/Headers/ReportsHeader";
import ExportModal from "../../components/Alerts/ExportModal";
import lsHelpers from "../../helpers/LsHelper";
import reportApiService from "../../api/report-api-service";
import ProBadge from "../../components/Alerts/ProBadge";
import subscriptionHelpers from "../../helpers/SubscriptionHelper";
import NotProModal from "../../components/Alerts/NotProModal";
import {RotateCircleLoading} from "react-loadingg";
import classnames from "classnames";
import {Line} from "react-chartjs-2";
import {chartExample2, chartOptionsReports, parseOptions} from "../../variables/charts";
import Chart from "chart.js";
import LoadingOverlay from "react-loading-overlay";
import {student_strings} from "../../translations/student_translations";
import stringHelpers from "../../helpers/StringHelper";
import TicketTypeChart from "../../components/reports/TicketTypeChart";
import ResourceApiService from "../../api/resource-api-service";

const reportCardStyle = {cursor: "pointer", minHeight: 180}
const commentStyle = {marginLeft: 14, height: "100%"}

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let studentStrings = new LocalizedStrings(student_strings);
let reportStrings = new LocalizedStrings(report_strings);

class Tables extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedReport: props.location.state ? props.location.state.reportName : null,
            reportDates: props.location.state ? props.location.state.reportDates : null,
            isLoading: false,
            activeNav: 1,
            activityChartData: null,
            ticketsData: null,
            showNotProModal: false,
        };

        console.log(this.props)

        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        localStorage.expiration_is_on = false
        if (window.Chart) {
            parseOptions(Chart, chartOptionsReports());
        }
        this.getReportSettings()
        this.getActivityData()
        this.getLocales()
        lsHelpers.setReportFilters(null)
    }

    getLocales() {
        this.setState({isLoading: true})
        ResourceApiService.loadLocales()
            .then(res => {
                this.setState({locales: res})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            })
            .finally(() => this.setState({isLoading: false}));
    }

    toggleExportModal() {
        this.setState({showExportModal: !this.state.showExportModal})
    }

    toggleNotProModal() {
        this.setState({showNotProModal: false})
    }

    render() {
        this.localize();

        return (
            <>
                {this.state.showNotProModal === true && <NotProModal showNotProModal={this.state.showNotProModal}
                                                                     toggleNotProModal={() => this.toggleNotProModal()}/>}

                <ReportsHeader showButtons={this.state.selectedReport !== null}
                               showExport={this.showExportInHeader()}
                               closeReport={this.closeReport.bind(this)}
                               exportData={this.exportData.bind(this)}/>
                {/* Page content */}
                <Container className="mt--7" fluid>

                    {this.state.showExportModal &&
                    <ExportModal showExportModal={this.state.showExportModal} error={this.state.error}
                                 toggleExportModal={() => this.toggleExportModal()}
                                 exportDataAction={this.exportDataAction.bind(this)}
                    />
                    }

                    <Row className="mt-5">
                        <div className="col">
                            <Card className="bg-default shadow">
                                <CardHeader className="bg-transparent border-0">
                                    <h3 className="text-white mb-0">{reportStrings.reports}</h3>
                                </CardHeader>
                                {this.state.selectedReport === null && !businessHelper.isTeacherSession() &&
                                <>
                                    {this.state.reportSettings &&
                                    <div style={{marginLeft: 38}}>
                                        <FormGroup>
                                            <div className="custom-control custom-checkbox mt-4"
                                            >
                                                <input
                                                    className="custom-control-input"
                                                    id="input-daily-cb"
                                                    type="checkbox"
                                                    onChange={this.handleChange}
                                                    checked={this.state.reportSettings && this.state.reportSettings.daily}
                                                />
                                                <label className="custom-control-label"
                                                       htmlFor="input-daily-cb">
                                                    {reportStrings.daily_activated}
                                                </label>
                                            </div>
                                        </FormGroup>
                                    </div>
                                    }
                                    <Row className="ml-4 mr-4">
                                        <Col lg="4">
                                            <Card className="card-stats mb-4 " style={reportCardStyle}
                                                  onClick={this.showReport.bind(this, constants.reports.dayReport)}>
                                                <CardBody>
                                                    <Row>
                                                        <div className="col">
                                                            <CardTitle
                                                                tag="h5"
                                                                className="text-uppercase text-muted mb-0"
                                                            >
                                                                {reportStrings.day_overview}
                                                            </CardTitle>
                                                        </div>

                                                        <Col className="col-auto">
                                                            <div
                                                                className="icon icon-shape bg-success text-white rounded-circle shadow">
                                                                <i className="fas fa-calendar-day"/>
                                                            </div>
                                                        </Col>
                                                        <div className="mt-3 mb-0 text-muted text-sm"
                                                             style={commentStyle}>
                                                            <span style={{
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: "pre-line"
                                                            }}>{reportStrings.formatString(reportStrings.day_overview_expl, businessHelper.business().name)}</span>
                                                        </div>

                                                    </Row>

                                                </CardBody>
                                            </Card>
                                        </Col>
                                        <Col lg="4">
                                            <Card className="card-stats mb-4 " style={reportCardStyle}
                                                  onClick={this.showReport.bind(this, constants.reports.monthReport)}>
                                                <CardBody>
                                                    <Row>
                                                        <div className="col">
                                                            <CardTitle
                                                                tag="h5"
                                                                className="text-uppercase text-muted mb-0"
                                                            >
                                                            <span style={{
                                                                display: "flex",
                                                                alignItems: "center"
                                                            }}>
                                                                {reportStrings.period_overview} <ProBadge/>
                                                            </span>
                                                            </CardTitle>
                                                        </div>

                                                        <Col className="col-auto">
                                                            <div
                                                                className="icon icon-shape bg-info text-white rounded-circle shadow">
                                                                <i className="fas fa-calendar-week"/>
                                                            </div>
                                                        </Col>
                                                        <div className="mt-3 mb-0 text-muted text-sm"
                                                             style={commentStyle}>
                                                            <span style={{
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: "pre-line",
                                                            }}>{reportStrings.formatString(reportStrings.period_overview_expl, businessHelper.business().name)}</span>
                                                        </div>
                                                    </Row>

                                                </CardBody>
                                            </Card>
                                        </Col>
                                        <Col lg="4">
                                            <Card className="card-stats mb-4 " style={reportCardStyle}
                                                  onClick={this.showReport.bind(this, constants.reports.ticketReport)}>
                                                <CardBody>
                                                    <Row>
                                                        <div className="col">
                                                            <CardTitle
                                                                tag="h5"
                                                                className="text-uppercase text-muted mb-0"
                                                            >
                                                            <span style={{
                                                                display: "flex",
                                                                alignItems: "center"
                                                            }}>
                                                                {reportStrings.ticket_report} <ProBadge/>
                                                            </span>
                                                            </CardTitle>
                                                        </div>

                                                        <Col className="col-auto">
                                                            <div
                                                                className="icon icon-shape bg-yellow text-white rounded-circle shadow">
                                                                <i className="fas fa-ticket-alt"/>
                                                            </div>
                                                        </Col>
                                                        <div className="mt-3 mb-0 text-muted text-sm"
                                                             style={commentStyle}>
                                                            <span style={{
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: "pre-line",
                                                            }}>{reportStrings.ticket_report_expl}</span>
                                                        </div>

                                                    </Row>

                                                </CardBody>
                                            </Card>
                                        </Col>
                                        <Col lg="4">
                                            <Card className="card-stats mb-4 " style={reportCardStyle}
                                                  onClick={this.showReport.bind(this, constants.reports.attendanceReport)}>
                                                <CardBody>
                                                    <Row>
                                                        <div className="col">
                                                            <CardTitle
                                                                tag="h5"
                                                                className="text-uppercase text-muted mb-0"
                                                            >
                                                            <span style={{
                                                                display: "flex",
                                                                alignItems: "center"
                                                            }}>
                                                                {reportStrings.attendance_report} <ProBadge/>
                                                            </span>
                                                            </CardTitle>

                                                        </div>
                                                        <Col className="col-auto">
                                                            <div
                                                                className="icon icon-shape bg-warning text-white rounded-circle shadow">
                                                                <i className="fas fa-users"/>
                                                            </div>
                                                        </Col>

                                                        <div className="mt-3 mb-0 text-muted text-sm"
                                                             style={commentStyle}>
                                                            <span style={{
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: "pre-line"
                                                            }}>{reportStrings.attendance_report_expl}</span>
                                                        </div>
                                                    </Row>

                                                </CardBody>
                                            </Card>
                                        </Col>

                                        <Col lg="4">
                                            <Card className="card-stats mb-4 " style={reportCardStyle}
                                                  onClick={this.showReport.bind(this, constants.reports.expiringTickets)}>
                                                <CardBody>
                                                    <Row>
                                                        <div className="col">
                                                            <CardTitle
                                                                tag="h5"
                                                                className="text-uppercase text-muted mb-0"
                                                            >
                                                            <span style={{
                                                                display: "flex",
                                                                alignItems: "center"
                                                            }}>
                                                                {reportStrings.expiring_tickets_report} <ProBadge/>
                                                            </span>
                                                            </CardTitle>

                                                        </div>
                                                        <Col className="col-auto">
                                                            <div
                                                                className="icon icon-shape bg-gray text-white rounded-circle shadow">
                                                                <i className="fas fa-ticket-alt"/>
                                                            </div>
                                                        </Col>

                                                        <div className="mt-3 mb-0 text-muted text-sm"
                                                             style={commentStyle}>
                                                            <span style={{
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: "pre-line"
                                                            }}>{reportStrings.expiring_tickets_report_expl}</span>
                                                        </div>
                                                    </Row>

                                                </CardBody>
                                            </Card>
                                        </Col>

                                        <Col lg="4">
                                            <Card className="card-stats mb-4 " style={reportCardStyle}
                                                  onClick={this.showReport.bind(this, constants.reports.incomeReport)}>
                                                <CardBody>
                                                    <Row>
                                                        <div className="col">
                                                            <CardTitle
                                                                tag="h5"
                                                                className="text-uppercase text-muted mb-0"
                                                            >
                                                            <span style={{
                                                                display: "flex",
                                                                alignItems: "center"
                                                            }}>
                                                                {reportStrings.income_report} <ProBadge/>
                                                            </span>
                                                            </CardTitle>

                                                        </div>
                                                        <Col className="col-auto">
                                                            <div
                                                                className="icon icon-shape bg-purple text-white rounded-circle shadow">
                                                                <i className="fas fa-money-bill-wave"/>
                                                            </div>
                                                        </Col>

                                                        <div className="mt-3 mb-0 text-muted text-sm"
                                                             style={commentStyle}>
                                                            <span style={{
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: "pre-line"
                                                            }}>{reportStrings.income_report_expl}</span>
                                                        </div>
                                                    </Row>

                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>

                                    <Row className="ml-4 mr-4">
                                        <Col lg="4">
                                            <Card className="card-stats mb-4 " style={reportCardStyle}
                                                  onClick={this.showReport.bind(this, constants.reports.renewableTicketReport)}>
                                                <CardBody>
                                                    <Row>
                                                        <div className="col">
                                                            <CardTitle
                                                                tag="h5"
                                                                className="text-uppercase text-muted mb-0"
                                                            >
                                                            <span style={{
                                                                display: "flex",
                                                                alignItems: "center"
                                                            }}>
                                                                {resourceStrings.subscriptions.subscriptions} <ProBadge/>
                                                            </span>
                                                            </CardTitle>
                                                        </div>

                                                        <Col className="col-auto">
                                                            <div
                                                                className="icon icon-shape bg-green text-white rounded-circle shadow">
                                                                <i className="fas fa-ticket-alt"/>
                                                            </div>
                                                        </Col>
                                                        <div className="mt-3 mb-0 text-muted text-sm"
                                                             style={commentStyle}>
                                                            <span style={{
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: "pre-line",
                                                            }}>{reportStrings.renewable_ticket_report}</span>
                                                        </div>

                                                    </Row>

                                                </CardBody>
                                            </Card>
                                        </Col>

                                        <Col lg="4">
                                            <Card className="card-stats mb-4 " style={reportCardStyle}
                                                  onClick={this.showReport.bind(this, constants.reports.studentWithUnpaidClassesReport)}>
                                                <CardBody>
                                                    <Row>
                                                        <div className="col">
                                                            <CardTitle
                                                                tag="h5"
                                                                className="text-uppercase text-muted mb-0"
                                                            >
                                                            <span style={{
                                                                display: "flex",
                                                                alignItems: "center"
                                                            }}>
                                                                {reportStrings.unpaid_report} <ProBadge/>
                                                            </span>
                                                            </CardTitle>
                                                        </div>

                                                        <Col className="col-auto">
                                                            <div
                                                                className="icon icon-shape bg-red text-white rounded-circle shadow">
                                                                <i className="fas fa-user-tag"/>
                                                            </div>
                                                        </Col>
                                                        <div className="mt-3 mb-0 text-muted text-sm"
                                                             style={commentStyle}>
                                                            <span style={{
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: "pre-line",
                                                            }}>{reportStrings.unpaid_report_expl}</span>
                                                        </div>

                                                    </Row>

                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </>
                                }
                                {this.state.selectedReport === null && !businessHelper.isTeacherSession() &&
                                <>
                                    <Row className="mt-4">
                                        <Col lg="12">
                                            {this.renderActivityReport()}
                                        </Col>
                                    </Row>

                                    {this.state.ticketData && !businessHelper.isTeacherSession() &&
                                    <Row className="mt-4">
                                        <Col lg="12">
                                            <LoadingOverlay
                                                active={this.state.isLoading}
                                                spinner={<RotateCircleLoading color="white"/>}
                                                text=''
                                            >
                                                <TicketTypeChart ticketData={this.state.ticketData}
                                                                 toggleNavs={this.toggleNavs}
                                                                 activeNav={this.state.activeNav}
                                                />
                                            </LoadingOverlay>
                                        </Col>
                                    </Row>
                                    }
                                </>
                                }
                                {this.state.selectedReport !== null &&
                                <Report type={this.state.selectedReport}
                                        locales={this.state.locales}
                                        redirectToReport={this.redirectToReport.bind(this)}
                                        period={this.state.reportDates}
                                />
                                }

                                {businessHelper.isTeacherSession() &&
                                <div className="text-center my-4 text-white">{resourceStrings.cant_access_feature}</div>
                                }
                            </Card>
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    renderActivityReport() {
        if (this.state.activityChartData !== null) {
            return <Card className="bg-gradient-default shadow">
                <LoadingOverlay
                    active={this.state.isLoading}
                    spinner={<RotateCircleLoading color="white"/>}
                    text=''
                >
                    <CardHeader className="bg-transparent">
                        {this.state.attendance_loading &&
                        <RotateCircleLoading color="white"/>
                        }
                        <CardTitle
                            className="text-white">{resourceStrings.tickets}, {resourceStrings.classes}, {stringHelpers.capitalize(studentStrings.students)}</CardTitle>
                        <Row className="align-items-center">
                            <div className="col">
                                <Nav className="justify-content-end" pills>
                                    <NavItem>
                                        <NavLink
                                            className={classnames("py-2 px-3", {
                                                active: this.state.activeNav === 1
                                            })}
                                            data-toggle="tab"
                                            href="#pablo"
                                            onClick={e => this.toggleNavs(e, 1)}
                                        >
                                            <span className="d-none d-md-block">{commonStrings.week}</span>
                                            <span
                                                className="d-md-none">{commonStrings.week.charAt(0)}</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames("py-2 px-3", {
                                                active: this.state.activeNav === 2
                                            })}
                                            href="#pablo"
                                            onClick={e => this.toggleNavs(e, 2)
                                            }
                                        >
                                            <span className="d-none d-md-block">{commonStrings.month}</span>
                                            <span
                                                className="d-md-none">{commonStrings.month.charAt(0)}</span>
                                        </NavLink>
                                    </NavItem>

                                    <NavItem>
                                        <NavLink
                                            className={classnames("py-2 px-3", {
                                                active: this.state.activeNav === 3
                                            })}
                                            href="#pablo"
                                            onClick={e => this.toggleNavs(e, 3)
                                            }
                                        >
                                            <span className="d-none d-md-block">{commonStrings.six_months}</span>
                                            <span
                                                className="d-md-none">6</span>
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </div>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        {/* Chart */}
                        <div className="chart">
                            <Line
                                data={this.state.activityChartData}
                                options={chartExample2.options}
                                getDatasetAtEvent={e => console.log(e)}
                            />
                        </div>
                    </CardBody>
                </LoadingOverlay>
            </Card>
        }
    }

    toggleNavs = (e, index) => {
        e.preventDefault();
        this.setState({
            activeNav: index
        });

        this.getActivityData(index === 1 ? "week" : index === 2 ? "month" : "3m")
    };

    getActivityData(type = "week") {
        this.setState({isLoading: true});

        reportApiService.business_analytics(type)
            .then(res => {
                this.setState({
                    isLoading: false,
                    activityChartData: res[0].data,
                    ticketData: res[1].data,
                });

            })
            .catch((e) => {
                this.handleNetworkError(e)
            })
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        reportStrings.setLanguage(loc);
    }

    closeReport(e) {
        e.preventDefault();
        this.setState({selectedReport: null})
    }

    exportData(e) {
        e.preventDefault();
        this.setState({showExportModal: true})
    }

    showReport(type) {
        if (type !== constants.reports.dayReport) {
            if (subscriptionHelpers.hasSubscription()) {
                this.setState({selectedReport: type})
            } else this.setState({showNotProModal: true})

        } else this.setState({selectedReport: type})
    }

    redirectToReport(reportName, period, filters) {
        this.setState(prevState => ({
            selectedReport: reportName,
            period: period,
            filters: filters
        }));
    }

    showExportInHeader() {
        return ![constants.reports.monthReport, constants.reports.incomeReport, constants.reports.renewableTicketReport, constants.reports.studentWithUnpaidClassesReport].includes(this.state.selectedReport)
    }

    exportDataAction() {
        this.toggleExportModal();

        const dates = lsHelpers.getReportDates();
        const filters = lsHelpers.getReportFilters();

        switch (this.state.selectedReport) {
            case constants.reports.ticketReport:
                this.exportTicketData(dates, filters);
                break;
            case constants.reports.expiringTickets:
                this.exportExpiringTicketData(dates);
                break;
            case constants.reports.attendanceReport:
                this.exportAttendanceData(dates);
                break;
            case constants.reports.incomeReport:
                this.exportIncomeData(dates);
                break;
            case constants.reports.dayReport:
                this.exportDailyReport();
                break;
            default:
                break;
        }
    }

    exportDailyReport() {
        reportApiService.sendDailyReport()
    }

    handleChange(event) {
        let targetId = event.target.id;
        let checkBoxValue = event.target.checked;

        if (targetId == "input-daily-cb") {
            this.setState({
                isLoading: true,
            });

            reportApiService.toggleDailyReports(businessHelper.business().id)
                .then(res => {
                    this.getReportSettings()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                })
                .finally(() => this.setState({isLoading: false}))
        }
    }

    getReportSettings() {
        reportApiService.reportSettings()
            .then(res => {
                this.setState({reportSettings: res})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            })
            .finally(() => this.setState({isLoading: false}))
    }

    exportTicketData(dates, filters) {
        reportApiService.exportTickets(dates, lsHelpers.getExpirationIsOn(), filters)
    }

    exportExpiringTicketData(dates) {
        reportApiService.exportExpiringTickets(dates)
    }

    exportAttendanceData(dates) {
        reportApiService.attendanceReport(dates)
    }

    exportIncomeData(dates) {

    }
}

export default Tables;
